/**
 * The DigitalJourneyAppFlow is a router that is responsible for the general flow of the application
 * The DigitalJourneyAppFlow is used only for the DigitalJourney flow
 */
import { useSetAtom } from "jotai";
import { useEffect } from "react";
import { Route, Routes } from "react-router-dom";

import { digitalJourneyFlowAtom } from "atoms/digitalJourneyAppFlow";

import { DigitalJourneyAppFlowJSX } from "./types";
import { RemoveTrailingSlash } from "app/AppFlow/RemoveTrailingSlash";
import { getDigitalJourneyFlowPages } from "./getDigitalJourneyFlowPages";

type DigitalJourneyAppFlowProps = {
  children: DigitalJourneyAppFlowJSX;
};

export const DigitalJourneyAppFlow = ({ children }: DigitalJourneyAppFlowProps) => {
  const setDigitalJourneyAppFlow = useSetAtom(digitalJourneyFlowAtom);

  const flowPages = getDigitalJourneyFlowPages(children);

  const appRoutes = flowPages
    .map((node) => ({
      path: node.props.path,
      checkpoint: node.props.checkpoint,
    }));

  useEffect(() => {
    setDigitalJourneyAppFlow(appRoutes);
  }, [appRoutes, setDigitalJourneyAppFlow]);

  return (
    <>
      <RemoveTrailingSlash />
      <Routes>
        {flowPages.map((child) => (
          <Route key={child.props.path} path={child.props.path} element={child} />
        ))}
      </Routes>
    </>
  );
};
